import { render, staticRenderFns } from "./TableVerificados.vue?vue&type=template&id=cc630466&scoped=true"
import script from "./TableVerificados.vue?vue&type=script&lang=js"
export * from "./TableVerificados.vue?vue&type=script&lang=js"
import style0 from "./TableVerificados.vue?vue&type=style&index=0&id=cc630466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc630466",
  null
  
)

export default component.exports